import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { GetAdditionalTableFields } from "../Utils";

export const ISolvedSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const additionalTableOptions = GetAdditionalTableFields(config.source).map(table => {
    return { label: table.alias, value: table.name };
  });

  const selectedAdditionalTables = config.additionalTables ?? [];

  const onAdditionalTableToggle = e => {
    const option = e.value;
    const tableHeader = option?.value;
    if (!tableHeader) return;
    let additionalTables = config.additionalTables ?? [];
    var currentIndex = additionalTables.findIndex(
      sourceItem => JSON.stringify(sourceItem) === JSON.stringify(tableHeader)
    );
    if (currentIndex > -1) additionalTables.splice(currentIndex, 1);
    else additionalTables.push(tableHeader);
    onChange({ ...config, additionalTables: additionalTables });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
      showAdditionalFields
      additionalFieldOptions={additionalTableOptions}
      selectedAdditionalFields={selectedAdditionalTables}
      onAdditionalFieldChange={onAdditionalTableToggle}
    />
  );
};
